import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { axiosClient } from '../../../core/axios-client'

const fetchHistories = createAsyncThunk(
  'fetchHistories',
  async () => {
    const requests = await axiosClient.get('/companies/selected/histories')
    return requests.data.results
  }
)

const initialState = {
    histories: [],
}

export const slice = createSlice({
  name: 'histories',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchHistories.fulfilled, (state, { payload }) => {
      state.histories = payload;
    })
  }
})

export {
  fetchHistories,
}

export default slice.reducer;
